const mutations = {
    setMenus(state, payload) {
        state.menus = payload;
    },
}

export default mutations;